<template>
  <el-popover placement="bottom" trigger="click" width="420" v-model="show">
    <el-button slot="reference" icon="el-icon-view" size="mini">查看处方</el-button>
    <div v-loading="loading" element-loading-text="数据加载中...">
      <div class="tabs-wrapper">
        <el-radio-group v-model="active" size="mini">
          <el-radio-button v-for="(item, index) in prescriptionList" :key="index"
            :label="item.S_OP_IO_Type_Name"></el-radio-button>
        </el-radio-group>
      </div>
      <div v-for="(item, index) in prescriptionList" :key="index">
        <div class="prescription-list" v-if="active === '框架远用' && item.S_OP_IO_Type === '0'">
          <div class="item">
            <span></span>
            <span>球镜</span>
            <span>柱镜</span>
            <span>轴向</span>
            <span>远用桥正视力</span>
            <span>OD</span>
            <span>{{ item.S_OP_IO_DSOD }}</span>
            <span>{{ item.S_OP_IO_DCOD }}</span>
            <span>{{ item.S_OP_IO_XOD }}</span>
            <span>{{ item.S_OP_IO_DVAOD }}</span>
            <span>OS</span>
            <span>{{ item.S_OP_IO_DSOS }}</span>
            <span>{{ item.S_OP_IO_DCOS }}</span>
            <span>{{ item.S_OP_IO_XOS }}</span>
            <span>{{ item.S_OP_IO_DVAOS }}</span>
          </div>
          <div class="item">
            <span></span>
            <span>近用矫正视力</span>
            <span>瞳距</span>
            <span>瞳高</span>
            <span>ADD</span>
            <span>OD</span>
            <span>{{ item.S_OP_IO_NVAOD }}</span>
            <span>{{ item.S_OP_IO_PDOD || 0 }}mm</span>
            <span>{{ item.S_OP_IO_PHOD || 0 }}mm</span>
            <span>{{ item.S_OP_IO_ADDOD }}</span>
            <span>OS</span>
            <span>{{ item.S_OP_IO_NVAOS }}</span>
            <span>{{ item.S_OP_IO_PDOS || 0 }}mm</span>
            <span>{{ item.S_OP_IO_PHOS || 0 }}mm</span>
            <span>{{ item.S_OP_IO_ADDOS }}</span>
          </div>
          <div class="item">
            <span></span>
            <span>垂直棱镜</span>
            <span>垂直基底</span>
            <span>水平棱镜</span>
            <span>水平基底</span>
            <span>OD</span>
            <span>{{ item.S_OP_IO_NVAOD }}</span>
            <span>{{ item.S_OP_IO_BasisOD_V }}</span>
            <span>{{ item.S_OP_IO_ArriseOD }}</span>
            <span>{{ item.S_OP_IO_BasisOD }}</span>
            <span>OS</span>
            <span>{{ item.S_OP_IO_NVAOS }}</span>
            <span>{{ item.S_OP_IO_BasisOS_V }}</span>
            <span>{{ item.S_OP_IO_ArriseOS }}</span>
            <span>{{ item.S_OP_IO_BasisOS }}</span>
          </div>
        </div>
        <div class="prescription-list" v-if="active === '框架近用' && item.S_OP_IO_Type === '2'">
          <div class="item">
            <span></span>
            <span>球镜</span>
            <span>柱镜</span>
            <span>轴向</span>
            <span></span>
            <span>OD</span>
            <span>{{ item.S_OP_IO_DSOD }}</span>
            <span>{{ item.S_OP_IO_DCOD }}</span>
            <span>{{ item.S_OP_IO_XOD }}</span>
            <span></span>
            <span>OS</span>
            <span>{{ item.S_OP_IO_DSOS }}</span>
            <span>{{ item.S_OP_IO_DCOS }}</span>
            <span>{{ item.S_OP_IO_XOS }}</span>
            <span></span>
          </div>
          <div class="item">
            <span></span>
            <span>近用视力矫正</span>
            <span>瞳距</span>
            <span></span>
            <span></span>
            <span>OD</span>
            <span>{{ item.S_OP_IO_NVAOD }}</span>
            <span>{{ item.S_OP_IO_PDOD }}</span>
            <span></span>
            <span></span>
            <span>OS</span>
            <span>{{ item.S_OP_IO_NVAOS }}</span>
            <span>{{ item.S_OP_IO_PDOS }}</span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="prescription-list" v-if="active === '角膜接触镜' && item.S_OP_IO_Type === '7'">
          <div class="item">
            <span></span>
            <span>球镜</span>
            <span>柱镜</span>
            <span>轴向</span>
            <span></span>
            <span>OD</span>
            <span>{{ item.S_OP_IO_DSOD }}</span>
            <span>{{ item.S_OP_IO_DCOD }}</span>
            <span>{{ item.S_OP_IO_XOD }}</span>
            <span></span>
            <span>OS</span>
            <span>{{ item.S_OP_IO_DSOS }}</span>
            <span>{{ item.S_OP_IO_DCOS }}</span>
            <span>{{ item.S_OP_IO_XOS }}</span>
            <span></span>
          </div>
          <div class="item">
            <span></span>
            <span>视力</span>
            <span>基弧</span>
            <span>镜片直径</span>
            <span></span>
            <span>OD</span>
            <span>{{ item.S_OP_IO_VAOD }}</span>
            <span>{{ item.S_OP_IO_BCOD }}</span>
            <span>{{ item.S_OP_IO_DIMOD }}</span>
            <span></span>
            <span>OS</span>
            <span>{{ item.S_OP_IO_VAOS }}</span>
            <span>{{ item.S_OP_IO_BCOS }}</span>
            <span>{{ item.S_OP_IO_DIMOS }}</span>
            <span></span>
          </div>
        </div>
      </div>
      <!-- 没有处方数据 -->
      <el-empty v-if="prescriptionList.length === 0" description="没有处方数据~~"></el-empty>
    </div>
  </el-popover>
</template>
<script>
import { getPrescriptionListApi } from '../api'
export default {
  name: 'PrescriptionListPopver',
  inject: ['chooseId'],
  data() {
    return {
      loading: false,
      show: false,
      active: '框架远用',
      prescriptionList: []
    }
  },
  methods: {
    async getPrescriptionList() {
      if (!this.chooseId) return;
      try {
        this.loading = true;
        const { data } = await getPrescriptionListApi(this.chooseId);
        if (data?.GetListResult?.length > 0) {
          const list = data.GetListResult.map(item => {
            const data = item.S_OP_Json.replace(/\*\*\*/g, '"');
            const S_OPData = JSON.parse(data);
            const typeObj = {
              '0': '框架远用',
              '2': '框架近用',
              '7': '角膜接触镜'
            };
            return {
              S_OP_ID: item.S_OP_ID,
              ...S_OPData,
              S_OP_IO_Type_Name: typeObj[S_OPData.S_OP_IO_Type]
            }
          });
          this.prescriptionList = list;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    show(newV) {
      if (newV && this.prescriptionList.length === 0) {
        this.getPrescriptionList();
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.tabs-wrapper {
  text-align: center;
  margin-bottom: 10px;
}

.prescription-list {
  .item {
    display: grid;
    grid-template-columns: 1fr 3fr 3fr 3fr 3fr;
    text-align: center;
    border: 1px solid #ebeef5;
    background-color: #f5f7fa;
    gap: 5px 0px;
    padding: 10px 5px;
    margin-bottom: 10px;
  }
}
</style>